import { useAuthContext } from "../../../../hooks/useAuthContext";
import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import { TabMenu } from "primereact/tabmenu";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Skeleton } from "primereact/skeleton";
import { BlockUI } from "primereact/blockui";
import studentsAPI from "../../../../services/students";
import MeaStudentRegistrationAvatar from "../../../../components/MeaStudentRegistrationAvatar";
import { Dropdown } from "primereact/dropdown";
// import levelsAPI from "../../../../services/levels";
// import classesAPI from "../../../../services/classes";
import MeaStudentStatus2 from "../../../../components/MeaStudentStatus2";
import statisticsAPI from "../../../../services/statistics";
import { Badge } from "primereact/badge";
import { useNavigate, useParams } from "react-router-dom";
import ImportRegistrationsFromExcelModal from "../modals/ImportRegistrationsFromExcelModal";
import uiDataAPI from "../../../../services/ui_data";
import { Toast } from "primereact/toast";
import tasksAPI from "../../../../services/tasks";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_CONTRACTS, PERMISSION_TRAINING_LEVELS, PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import UpdateRegistrationAffectationModal from "../modals/UpdateRegistrationAffectationModal";
import { Menu } from "primereact/menu";
import MeaStudentPreviousResult from "../../components/MeaStudentPreviousResult";
import MeaLink from "../../../../components/MeaLink";
import levelsAPI from "../../../../services/levels";
import classesAPI from "../../../../services/classes";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import FamilyInfoModal from "../../components/FamilyInfoModal";
import ConfirmRegistrationModal from "../modals/ConfirmRegistrationModal";

const CandidatesListComponent = forwardRef((props, ref) => {
  const { filter, showExportButton = false, showFilterButton, schoolId, trainingId } = props;
  const { auth, currentMembership, hasPermission } = useAuthContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const accessToken = "";
  const memberId = currentMembership?.id;
  //
  const navigate = useNavigate();
  //

  //
  const importRegistrationsFromExcelModalRef = useRef();
  const familyInfoModalRef = useRef();
  const confirmRegistrationModalRef = useRef();
  //
  const [selectedTab, setSelectedTab] = useState(0);
  const [isTabLoading, setIsTabLoading] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState(filter?.name || "");
  const [state, setState] = useUrlState({
    registrationsPage: "1",
    registrationsPageSize: "50",
    registrationsFilter: JSON.stringify({
      level_id: filter?.level_id || "",
      classe_id: filter?.classe_id || "",
      name: filter?.name || "",
      status: filter?.status || "",
      registration_new: filter?.registration_new || "",
      previous_level_name: filter?.previous_level_name || "",
      previous_class_name: filter?.previous_class_name || "",
      has_contract: filter?.has_contract || "",
    }),
  });
  const setFilter = (field, value) => {
    let currentFilter = state?.registrationsFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      registrationsPage: 1,
      registrationsFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  const toast = useRef(null);
  const registrationsRef = useRef(null);
  const updateAffectationRef = useRef();
  const searchInputRef = useRef();
  //
  const hasGetContractsPermission = hasPermission(PERMISSION_TRAINING_CONTRACTS.GET)
  const hasCreateRegistrationPermission = hasPermission(PERMISSION_TRAINING_REGISTRATION.CREATE)
  const hasImportRegistrationFromFilePermission = hasPermission(PERMISSION_TRAINING_TASKS.IMPORT_REGISTRATIONS_FROM_EXCEL_FILE)
  const hasImportRegistrationFromTrainingPermission = hasPermission(PERMISSION_TRAINING_TASKS.IMPORT_FROM_TRAINING)
  //
  const statsQuery = statisticsAPI.useGetStudentsRegistrationsStats(
    schoolId,
    trainingId,
    accessToken
  );

  //
  const queryList = studentsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.registrationsFilter)
  );

  const levelsQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000,
    {
      level_id: JSON.parse(state.registrationsFilter)?.level_id,
    }
  );
  const UiDataStudentResultTypesListQuery = uiDataAPI.UiDataStudentResultTypesList(
    accessToken
  );
  //
  const setStudentStatus = useCallback(
    (status) => {
      setFilter("status", status || "");
    },
    [setState]
  );
  //
  const filterCombobox = (options, query, field) => {
    return (
      <Dropdown
        value={query?.data?.data?.find(
          (obj) => obj.id === JSON.parse(state.registrationsFilter)[field]
        )}
        options={query?.data?.data}
        optionLabel="name"
        onChange={(e) => {
          //options.filterApplyCallback(e.value);
          setIsTabLoading(true);
          setFilter(field, e.value?.id || "");
        }}
        //itemTemplate={statusItemTemplate}
        placeholder="Séléctionner"
        className="p-column-filter"
        showClear
      />
    );
  };
  //
  const setSearchName = (name) => {
    setFilter("name", name || "");
  };
  //
  const handleSearch = () => {
    setIsTabLoading(true);
    setSearchName(searchInputValue);
  };
  //
  const handleClear = () => {
    const currentFilter = JSON.parse(state.registrationsFilter);
    if (currentFilter?.name !== "") {
      setIsTabLoading(true);
    }
    setSearchInputValue("");
    setSearchName("");
    
  };
  //
  useEffect(() => {
    switch (JSON.parse(state.registrationsFilter)?.status) {
      case "":
        setSelectedTab(0);
        break;
      case "NEW":
        setSelectedTab(4);
        break;
      case "PREREGISTRED":
        setSelectedTab(1);
        break;
      case "ENROLLED":
        setSelectedTab(2);
        break;
      case "WAITING_LIST":
        setSelectedTab(5);
        break;
      case "UNREGISTRED":
        setSelectedTab(3);
        break;
      default:
        setSelectedTab(0);
        break;
    }
  }, [state.registrationsFilter]);

  // Sync search input value with filter state
  useEffect(() => {
    const currentFilter = JSON.parse(state.registrationsFilter);
    if (currentFilter?.name !== searchInputValue) {
      setSearchInputValue(currentFilter?.name || "");
    }
  }, [state.registrationsFilter]);

  // Reset loading state when query data changes
  useEffect(() => {
    if (queryList?.data && !queryList?.isLoading) {
      setIsTabLoading(false);
    }
  }, [queryList?.data, queryList?.isLoading]);

  //
  const handleTabChange = useCallback(
    (selectedTabIndex) => {
      setIsTabLoading(true);
      var selectedStatus = "";
      switch (selectedTabIndex) {
        case 0:
          selectedStatus = "";
          break;
        case 4:
          selectedStatus = "NEW";
          break;
        case 1:
          selectedStatus = "PREREGISTRED";
          break;
        case 2:
          selectedStatus = "ENROLLED";
          break;
        case 5:
          selectedStatus = "WAITING_LIST";
          break;
        case 3:
          selectedStatus = "UNREGISTRED";
          break;
        default:
          selectedStatus = "";
          break;
      }
      setStudentStatus(selectedStatus);
      setState((prevState) => ({
        ...prevState,
        registrationsPage: 1,
        registrationsPageSize: 50,
        registrationsFilter: JSON.stringify({
          ...JSON.parse(prevState.registrationsFilter),
          status: selectedStatus,
          level_id: "",
          classe_id: "",
          name: "",
          member_id: "",
          previous_result: "",
          is_new: "",
          has_contract: "",
          previous_level_name: "",
          previous_class_name: "",
        }),
      }));
      // Reset search input value when tab changes
      setSearchInputValue("");
    },
    [setStudentStatus]
  );
  //
  const [jobId, setJobId] = useState(null);
  useEffect(() => {
    const fetchTaskStatus = async () => {
      tasksAPI.GetTask(schoolId, trainingId, jobId, auth?.access_token)
        .then((data) => {
          if (data?.data?.status === "COMPLETED") {
            {
              toast.current.clear();
              toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Traitement fini' });
              setJobId(null);
              queryList?.refetch();
              statsQuery?.refetch();
            }
          } else if (data?.data?.status === "FAILED") {
            {
              toast.current.clear();
              toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Error lors du traitement!' });
              setJobId(null);
            }
          }
          else {
            setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setJobId(null);
          queryList?.refetch();
          statsQuery?.refetch();
        });
    };

    if (jobId) {
      fetchTaskStatus();
    }

  }, [jobId]);
  //
  //
  const acceptPreRegistred = () => {
    toast.current.show({ severity: 'info', summary: 'Confirmé', detail: 'Traitement en cours..' });
    let elements = registrationsRef.current.getSelectedElements();
    tasksAPI.UpdateRegistrationsStatus(schoolId, trainingId, accessToken, {
      registrations_ids: elements?.map((element) => {
        return element.id;
      }),
      new_status: "PREREGISTRED",
      registration_confirmation_by_id: memberId
    }).then((data) => {
      setJobId(data?.data?.id);
    }).catch((error) => {
      console.log("error", error);
    });
  };

  const acceptUnregistered = () => {
    toast.current.show({ severity: 'info', summary: 'Confirmé', detail: 'Traitement en cours..' });
    let elements = registrationsRef.current.getSelectedElements();
    tasksAPI.UpdateRegistrationsStatus(schoolId, trainingId, accessToken, {
      registrations_ids: elements?.map((element) => {
        return element.id;
      }),
      new_status: "UNREGISTRED",
      registration_confirmation_by_id: memberId
    }).then((data) => {
      setJobId(data?.data?.id);
    }).catch((error) => {
      console.log("error", error);
    });
  };
  const confirmMoveToPreRegistred = (event) => {
    // confirm to move selected students to ongoing
    confirmPopup({
      target: event.currentTarget,
      message: 'Voulez-vous vraiment pré-inscrire les élèves sélectionnés?',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: acceptPreRegistred
    });
  };
  const confirmMoveToEnrolled = (event) => {
    let elements = registrationsRef.current.getSelectedElements();
    if (elements && elements.length > 0) {
      confirmRegistrationModalRef.current.show(elements, () => {
        queryList?.refetch();
        statsQuery?.refetch();
      });
    }
  };
  const confirmMoveToUnregistered = (event) => {
    // confirm to move selected students to unregistered
    confirmPopup({
      target: event.currentTarget,
      message: 'Voulez-vous vraiment désinscrire les élèves sélectionnés?',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: acceptUnregistered
    });
  };
  //
  const handleAffectStudentsToclass = () => {
    let elements = registrationsRef.current.getSelectedElements();
    if (elements.length > 0) {
      if (updateAffectationRef.current) {
        updateAffectationRef.current.show(elements, () => {
          queryList?.refetch();
        });
      }
    }
  }

  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
    getSelectedElements: () => {
      return registrationsRef.current.getSelectedElements();
    },
  }));
  //
  //
  const startToolbarTemplate = (
    <div className="mr-2">

      <span className="p-input-icon-left mr-2 ">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText
          id="search"
            ref={searchInputRef}
            value={searchInputValue}
            onChange={(e) => setSearchInputValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            placeholder="Chercher un dossier"
          />
        </IconField>
      </span>
      <MeaButton
        onClick={handleSearch}
        icon="pi pi-search"
      />
      {searchInputValue && (
        <MeaButton
          onClick={handleClear}
          icon="pi pi-times"
          outlined
          disabled={isTabLoading}
          className="ml-2"
        />
      )}
    </div>
  );
  const selectedToolbarTemplate = (
    <>

      {(selectedTab === 2) && <><MeaButton label="Affectation à une classe" outlined
        className="p-button mr-2 action"
        onClick={handleAffectStudentsToclass}
        permission={PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_CLASS}
      /></>}
      {(selectedTab === 1) && <><MeaButton label="Confirmer l'inscription"
        className="p-button mr-2 action"
        severity="success"
        onClick={confirmMoveToEnrolled}
        permission={PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS}
      />
      <MeaButton label="Désinscrire"
        className="p-button mr-2 action"
        severity="danger"
        onClick={confirmMoveToUnregistered}
        permission={PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS}
      /></>}


    </>
  );

  const registrationNewOptions = [{ id: "true", name: "Nouveaux" }, { id: "false", name: "Anciens" }];
  const contractFilterOptions = [
    { id: "", name: "Tous" },
    { id: "true", name: "Avec contrat" },
    { id: "false", name: "Sans contrat" }
  ];
  //
  return (
    <>
      <Toast position="bottom-center" ref={toast} />
      <UpdateRegistrationAffectationModal ref={updateAffectationRef} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
      <FamilyInfoModal ref={familyInfoModalRef} schoolId={schoolId} trainingId={trainingId} />
      <ConfirmPopup />


      <div className="mb-4">
        <TabMenu
          disabled={isTabLoading}
          model={[
            {
              label: (
                <div className="flex align-items-center gap-2">
                  <span>Tous</span>
                  {statsQuery?.isLoading ? (
                    <Skeleton width="2rem" height="1.5rem" />
                  ) : (
                    <Badge value={statsQuery?.data?.data?.all_students_count} className="bg-gray-500" />
                  )}
                </div>
              ),
              icon: "pi pi-fw pi-list",
              command: () => handleTabChange(0)
            },
            {
              label: (
                <div className="flex align-items-center gap-2">
                  <span>Pré-inscriptions</span>
                  {statsQuery?.isLoading ? (
                    <Skeleton width="2rem" height="1.5rem" />
                  ) : (
                    <Badge value={statsQuery?.data?.data?.preregistred_students_count} severity="info" />
                  )}
                </div>
              ),
              icon: "pi pi-fw pi-user-plus",
              command: () => handleTabChange(1)
            },
            {
              label: (
                <div className="flex align-items-center gap-2">
                  <span>Inscriptions confirmées</span>
                  {statsQuery?.isLoading ? (
                    <Skeleton width="2rem" height="1.5rem" />
                  ) : (
                    <Badge value={statsQuery?.data?.data?.enrolled_students_count} severity="success" />
                  )}
                </div>
              ),
              icon: "pi pi-fw pi-check-circle",
              command: () => handleTabChange(2)
            },
            {
              label: (
                <div className="flex align-items-center gap-2">
                  <span>Désinscrits</span>
                  {statsQuery?.isLoading ? (
                    <Skeleton width="2rem" height="1.5rem" />
                  ) : (
                    <Badge value={statsQuery?.data?.data?.unregistred_students_count} severity="danger" />
                  )}
                </div>
              ),
              icon: "pi pi-fw pi-times-circle",
              command: () => handleTabChange(3)
            },
            {
              label: (
                <div className="flex align-items-center gap-2">
                  <span>Nouvelles candidatures</span>
                  {statsQuery?.isLoading ? (
                    <Skeleton width="2rem" height="1.5rem" />
                  ) : (
                    <Badge value={statsQuery?.data?.data?.new_students_count} severity="contrast" />
                  )}
                </div>
              ),
              icon: "pi pi-fw pi-file-o",
              command: () => handleTabChange(4)
            },
            {
              label: (
                <div className="flex align-items-center gap-2">
                  <span>En liste d'attente</span>
                  {statsQuery?.isLoading ? (
                    <Skeleton width="2rem" height="1.5rem" />
                  ) : (
                    <Badge value={statsQuery?.data?.data?.waitinglist_students_count} severity="warning" />
                  )}
                </div>
              ),
              icon: "pi pi-fw pi-clock",
              command: () => handleTabChange(5)
            }
          ]}
          activeIndex={selectedTab}
          onTabChange={(e) => handleTabChange(e.index)}
        />
        {isTabLoading && (
          <div className="flex justify-content-center mt-3">
            <div className="flex align-items-center gap-2">
              <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>
              <span className="text-sm text-500">Chargement en cours...</span>
            </div>
          </div>
        )}
      </div>
      <div className="mt-4">
        <BlockUI 
          blocked={isTabLoading || queryList?.isLoading} 
          
        >
          <MeaDataTable
            ref={registrationsRef}
            query={queryList}
            serviceAPI={studentsAPI}
            names={{
              pagination: "registrations",
              singular: "inscription",
              plural: "inscriptions",
            }}
            schoolId={schoolId}
            trainingId={trainingId}
            startToolbarTemplate={startToolbarTemplate}
            selectedToolbarTemplate={selectedToolbarTemplate}
            showDeleteButton={false /*hasPermission(PERMISSION_TRAINING_REGISTRATION.DELETE)*/}
            showFilterButton={showFilterButton}
            showFilter={true}
            customFilterState={state.registrationsFilter}
            excludeFilterFields={["status", "name"]}
            setPage={setPage}
            setPageSize={setPageSize}
            page={state.registrationsPage}
            pageSize={state.registrationsPageSize}
            rowClassName={(data) => {
              return data?.registration_new === true ? "bg-indigo-50" : "";
            }}
            paginatorPosition="top"
            scrollable={false}
            scrollHeight="auto"
          >
            <Column
              style={{ width: '30px' }}
              selectionMode="multiple"
            ></Column>

            <Column
              style={{ minWidth: '270px', width: '270px' }}
              header="Elève"
              frozen
              body={(student) => <MeaStudentRegistrationAvatar student={student} schoolId={schoolId} trainingId={trainingId} permission={PERMISSION_TRAINING_REGISTRATION.GET} />}
            ></Column>
            <Column
              style={{ minWidth: '150px' }}
              field="status"
              header="Status"
              body={(item) => {
                return (<div className="flex align-items-center gap-2 no-wrap"><MeaButton
                  icon="pi pi-users"
                  tooltip="Voir les informations familiales"
                  className="p-button-text p-button-sm"
                  onClick={() => {
                    if (familyInfoModalRef.current) {
                      familyInfoModalRef.current.show(item);
                    }
                  }}
                /><MeaStudentStatus2 student={item} /></div>);
              }}
            ></Column>
            <Column
              style={{ minWidth: '150px' }}
              header="Date de naissance"
              field="birthday"
              body={(item) => {
                return item?.birthday ? item.birthday : "-";
              }}
            ></Column>
            {selectedTab === 1 && (
              <Column
                style={{ minWidth: '150px' }}
                header="Age"
                field="age"
                body={(item) => {
                  return item?.age ? item?.age : "-";
                }}
              ></Column>
            )}
            {selectedTab === 2 && (<Column
              style={{ minWidth: '150px' }}
              field="level"
              header="Niveau"
              body={(item) => (
                <MeaLink
                  to={
                    "/school/" +
                    schoolId +
                    "/admin/trainings/" +
                    trainingId +
                    "/levels/" +
                    item?.level?.id
                  }
                  permission={PERMISSION_TRAINING_LEVELS.GET}
                >
                  {item?.level?.name}
                </MeaLink>
              )}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) =>
                filterCombobox(options, levelsQuery, "level_id")
              }
            ></Column>
            )}
            {selectedTab === 2 && (<Column
              style={{ minWidth: '150px' }}
              field="classe"
              header="Classe"
              body={(item) => (
                item?.classe?.id ? (
                  <MeaLink
                    to={
                      "/school/" +
                      schoolId +
                      "/admin/trainings/" +
                      trainingId +
                      "/classes/" +
                      item?.classe?.id
                    }
                    permission={PERMISSION_TRAINING_CLASSES.GET}
                  >
                    {item?.classe?.name}
                  </MeaLink>
                ) : (
                  <Tag severity="warning" value="Non affecté" />
                )
              )}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) => {
                const classFilterOptions = [
                  { id: "unassigned", name: "Non affecté" },
                  ...(classesQuery?.data?.data || []),
                ];
                return (
                  <Dropdown
                    value={classFilterOptions.find(
                      (obj) => obj.id === JSON.parse(state.registrationsFilter)["classe_id"]
                    )}
                    options={classFilterOptions}
                    optionLabel="name"
                    onChange={(e) => {
                      setIsTabLoading(true);
                      setFilter("classe_id", e.value?.id || "");
                    }}
                    placeholder="Séléctionner"
                    className="p-column-filter"
                    showClear
                  />
                );
              }}
            ></Column>)}
            {(selectedTab === 1 || selectedTab === 2 || selectedTab === 3) && (
              <Column
                style={{ minWidth: '150px' }}
                field="previous_level_name"
                header="Dernier niveau"
                filter
                body={(item) => {
                  return item?.previous_level_name ? item?.previous_level_name : "-";
                }}
                showFilterMenu={false}
                showClearButton={true}
                filterElement={(options) => <InputText
                  value={JSON.parse(state.registrationsFilter)?.previous_level_name}
                  onChange={(e) => setFilter("previous_level_name", e.target.value)}
                />}
              ></Column>
            )}
            {(selectedTab === 1 || selectedTab === 2 || selectedTab === 3) && (
              <Column
                style={{ minWidth: '150px' }}
                field="previous_class_name"
                header="Dernière classe"
                filter
                body={(item) => {
                  return item?.previous_class_name ? item?.previous_class_name : "-";
                }}
                showFilterMenu={false}
                showClearButton={true}
                filterElement={(options) => <InputText
                  value={JSON.parse(state.registrationsFilter)?.previous_class_name}
                  onChange={(e) => setFilter("previous_class_name", e.target.value)}
                />}
              ></Column>
            )}
            {(selectedTab === 1 || selectedTab === 2 || selectedTab === 3) && (<Column
              style={{ minWidth: '150px' }}
              field="previous_result"
              header="Dernier résultat"
              body={(item) => {
                return <MeaStudentPreviousResult student={item} />;
              }}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) =>
                filterCombobox(options, UiDataStudentResultTypesListQuery, "previous_result")
              }
            ></Column>)}
            {(selectedTab === 1 || selectedTab === 2) && (
              <Column
                style={{ minWidth: '150px' }}
                field="previous_result_observation"
                header="Dernière observation"
                body={(item) => {
                  return item?.previous_result_observation ? item?.previous_result_observation : "-";
                }}
              ></Column>
            )}
            {(selectedTab === 3) && (
              <Column
                style={{ minWidth: '150px' }}
                field="unregistration_reason"
                header="Motif de désinscription"
                body={(item) => {
                  return item?.unregistration_reason ? item?.unregistration_reason : "-";
                }}
              ></Column>
            )}
            {(selectedTab === 4) && (
              <Column
                style={{ minWidth: '150px' }}
                field="registration_details"
                header="Message des parents"
                body={(item) => {
                  return item?.registration_details ? item?.registration_details : "-";
                }}
              ></Column>
            )}
            {(selectedTab === 4) && (
              <Column
                style={{ minWidth: '150px' }}
                field="registration_feedback"
                header="Message de l'école"
                body={(item) => {
                  return item?.registration_feedback ? item?.registration_feedback : "-";
                }}
              ></Column>
            )}
            {(selectedTab === 4) && (
              <Column
                style={{ minWidth: '150px' }}
                field="created_at"
                header="Date de création"
                body={(item) => {
                  return item?.created_at ? ToFormatedDateForEvents(new Date(item.created_at), false) : "-";
                }}
              ></Column>
            )}
            {(selectedTab === 5) && (
              <Column
                style={{ minWidth: '150px' }}
                field="on_waiting_list_details"
                header="Message de l'école"
                body={(item) => {
                  return item?.on_waiting_list_details ? item?.on_waiting_list_details : "-";
                }}
              ></Column>
            )}
            {(selectedTab === 1 || selectedTab === 2 || selectedTab === 0) && (<Column header="Nouveau?"
              style={{ minWidth: '150px' }}
              field="registration_new"
              body={(item) => {
                return item?.registration_new ? <Tag severity="primary" value="nouveau"></Tag> : "";
              }}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) =>
                <Dropdown
                  value={registrationNewOptions.find(
                    (obj) => obj.id === JSON.parse(state.registrationsFilter)["registration_new"]
                  )}
                  options={registrationNewOptions}
                  optionLabel="name"
                  onChange={(e) => {
                    const selectedId = e.value?.id || "";
                    if (options?.filterApplyCallback) {
                      options.filterApplyCallback(selectedId || null);
                    }
                    setFilter("registration_new", selectedId);
                  }}
                  //itemTemplate={statusItemTemplate}
                  placeholder="Séléctionner"
                  className="p-column-filter"
                  showClear
                />
                //filterCombobox(options, levelsQuery, "registration_new")
              }
            ></Column >)}
            {selectedTab === 2 && (
              <Column
                style={{ minWidth: '150px' }}
                field="has_contract"
                header="Contrat"
                body={(item) => {
                  return item?.contract_id && <MeaButton disabled={!hasGetContractsPermission} icon="pi pi-credit-card" tooltip="Voir le contrat" className="p-button-text" onClick={() => {
                    navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/contracts/" + item?.contract_id);
                  }} />;
                }}
                filter
                showFilterMenu={false}
                showClearButton={false}
                filterElement={(options) =>
                  <Dropdown
                    value={contractFilterOptions.find(
                      (obj) => obj.id === JSON.parse(state.registrationsFilter)["has_contract"]
                    )}
                    options={contractFilterOptions}
                    optionLabel="name"
                    placeholder="Tous"
                    onChange={(e) => {
                      const selectedId = e.value?.id || "";
                      setIsTabLoading(true);
                      setFilter("has_contract", selectedId);
                    }}
                    className="p-column-filter"
                    style={{ minWidth: "8rem" }}
                    showClear
                  />
                }
              ></Column>
            )}
            
            {/* 
        <Column
          body={(item) => (
            <>
              <MeaButton 
                icon="pi pi-pencil"
                rounded
                text
                aria-label="Filter"
                onClick={() => {
                  setSelectedStudent(item);
                  //if (updateAffectationRef.current) {
                  //  updateAffectationRef.current.show(() => {
                  //    queryList.refetch();
                  //  });
                  //}
                }}
              />
            </>
          )}
          headerStyle={{ width: "10%", minWidth: "8rem" }}
          bodyStyle={{ textAlign: "center" }}
        ></Column>*/}
          </MeaDataTable>
        </BlockUI>

      </div>
      <ImportRegistrationsFromExcelModal ref={importRegistrationsFromExcelModalRef} schoolId={schoolId} trainingId={trainingId} />
      <ConfirmRegistrationModal ref={confirmRegistrationModalRef} schoolId={schoolId} trainingId={trainingId} memberId={memberId} />
    </>
  );
});

export default CandidatesListComponent;
